import { useEffect, useState } from 'react';
import { base64ToBlob } from '@/services/documents';

/**
 * An object URL over base64 bytes, revoked when they change or the card unmounts.
 *
 * An object URL rather than a `data:` one because the card's "New Tab" link is a
 * top-level navigation, and browsers block those to `data:` URLs.
 */
export function useObjectUrl(contentBase64: string | null | undefined, contentType: string): string | undefined {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!contentBase64) {
      setUrl(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(base64ToBlob(contentBase64, contentType));
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [contentBase64, contentType]);

  return url;
}
